export const NAME = 'name';
export const RESERVATION_ID = 'reservationId';
export const EXTRAS = 'extras';
export const PRICING = 'pricing';
